import { Button, notify } from '@hive/component';
import { SettingRow } from '@hive/component/setting-components';
import { useAsyncCallback } from '@hive/core/components/hooks/hive-async-hooks';
import { useMutation } from '@hive/core/components/hooks/use-mutation';
import { UrlService } from '@hive/core/modules/url';
import { UserFriendlyError } from '@hive/error';
import { createCustomerPortalMutation } from '@hive/graphql';
import { useI18n } from '@hive/i18n';
import { useService } from '@toeverything/infra';

import * as styles from './styles.css';

export const PaymentMethodUpdater = () => {
  const { isMutating, trigger } = useMutation({
    mutation: createCustomerPortalMutation,
  });
  const urlService = useService(UrlService);
  const t = useI18n();

  const update = useAsyncCallback(async () => {
    await trigger(null, {
      onSuccess: data => {
        urlService.openExternal(data.createCustomerPortal);
      },
    }).catch(e => {
      const userFriendlyError = UserFriendlyError.fromAny(e);
      notify.error(userFriendlyError);
    });
  }, [trigger, urlService]);

  return (
    <SettingRow
      className={styles.paymentMethod}
      name={t['com.hive.payment.billing-setting.payment-method']()}
      desc={t[
        'com.hive.payment.billing-setting.payment-method.description'
      ]()}
    >
      <Button onClick={update} loading={isMutating} disabled={isMutating}>
        {t['com.hive.payment.billing-setting.payment-method.go']()}
      </Button>
    </SettingRow>
  );
};
